<template>
  <div class="datetimepicker-container">
    <div class="datetimepicker--content-2">
      <button
        class="btn-text datetimepicker-main-button--hover"
        :title="$t('sectionDateTimePicker.scheduleAMessageToBeSent')"
        @click="onMainButtonClick"
      >
        <i class="far fa-calendar-alt"></i>
      </button>
    </div>

    <div
      v-show="abrir"
      v-click-outside="onClickOutside"
      class="datetimepicker-content"
    >
      <form
        class="datetimepicker--content-1"
        @submit="onFormSubmit"
        @reset="onFormReset"
      >
        <div class="row">
          <div class="col">
            <label for="">{{
              $t("sectionDateTimePicker.scheduleMessage")
            }}</label>
          </div>
        </div>
        <div v-if="!getBrowser()">
          <!-- is other -->
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="data">{{ $t("sectionDateTimePicker.date") }}</label>
                <input
                  id="data"
                  v-model="data"
                  name="data"
                  class="form-control"
                  type="date"
                  min="2018-06-07T00:00"
                  max="2018-06-14T00:00"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="time">{{ $t("sectionDateTimePicker.time") }}</label>
                <input
                  id="time"
                  v-model="hora"
                  name="time"
                  class="form-control"
                  type="time"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- is chrome -->
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="data">{{
                  $t("sectionDateTimePicker.fillInTheDateAndTime")
                }}</label>
                <input
                  id="data1"
                  v-model="data"
                  name="data1"
                  class="form-control"
                  type="datetime-local"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="datetimepicker-content-footer">
          <button class="btn btn-success" type="submit">
            {{ $t("sectionDateTimePicker.schedule") }}
          </button>
          <button class="btn btn-danger ml-auto" type="reset">
            {{ $t("sectionDateTimePicker.cancel") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateTimePicker",
  props: {
    evento: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      abrir: false,
      data: null,
      hora: null
    }
  },
  methods: {
    onClickOutside() {
      this.abrir = false
    },
    onMainButtonClick() {
      this.abrir = !this.abrir
      if (this.abrir) {
        this.data = null
        this.hora = null
      }
    },
    onFormSubmit(e) {
      e.preventDefault()

      if (this.getBrowser()) {
        this.data = new Date(this.data)
      } else {
        this.data = new Date(this.data + "T" + this.hora)
      }

      // console.log("input time", this.controller.inputTime);
      // console.log("date picked", this.controller.datePicked);
      // console.log("controller", this.controller);
      this.abrir = false
      // console.log("Executar emit", this.controller.datePicked);
      this.$emit(this.evento, this.data)
    },
    checkDatePicked() {
      return this.data ? true : false
    },
    getDate() {
      if (this.data)
        return (
          this.data.toLocaleTimeString() + ", " + this.data.toLocaleDateString()
        )
    },
    onFormReset(e) {
      // console.log("[onFormReset] Event:", e);
      this.reset()
      this.abrir = false
      //   this.$emit("onDateScheduled", this.controller.datePicked);
    },
    reset() {
      this.data = null
      // this.controller.showBox = false;
      // this.controller.inputDateTimeLocal = "";
      // this.controller.inputTime = "";
      // this.controller.datePicked = "";
    },
    getBrowser() {
      try {
        return (
          !!window.chrome &&
          (!!window.chrome.webstore || !!window.chrome.runtime)
        )
      } catch (error) {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
// @import "./scss/components/buttons.scss";
@import "./scss/main.scss";

.datetimepicker {
  &-container {
    position: relative;
    margin-left: auto;
    display: flex;
  }

  &-content {
    position: absolute;
    top: -14rem;
    left: -14.8rem;
    width: 15rem;
    height: 16rem;
    padding: 1rem 1rem 0.2rem 1rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background: $white-1;
    box-shadow: $shadow-content-2;
  }

  &--content-1 {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  &--content-2 {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }

  &-content-footer {
    margin: auto 0rem 1rem 0rem;
    display: flex;
  }

  // &-main-button {
  //   @include btn-text;
  // }
}

.datepicked-text {
  color: $blue-highlight-1;
  font-weight: 600;
  align-self: center;
  text-align: center;
}
</style>
